import React from 'react';

export function LoadingMessage() {
  return (
    <div className="flex items-center">
      <div className="text-[#361e06] font-semibold mr-[10px]">Searching the Bible for answers</div>
      <div className="flex gap-1">
        <div className="w-2 h-2 bg-[#361e06] rounded-full animate-bounce [animation-delay:-0.3s]" />
        <div className="w-2 h-2 bg-[#361e06] rounded-full animate-bounce [animation-delay:-0.15s]" />
        <div className="w-2 h-2 bg-[#361e06] rounded-full animate-bounce" />
      </div>
    </div>
  );
}